<!-- Extension point: theme head top -->
<!-- Renders head tags with position="top" from config.site.head -->

<if=$global.headTop && $global.headTop.length>
  <for|tag| of=$global.headTop>
    <if=tag.length === 3>
      <${tag[0]} ...tag[1]>
        ${tag[2]}
      </${tag[0]}>
    </if>
    <else>
      <${tag[0]} ...tag[1]/>
    </else>
  </for>
</if>
